import React from 'react'
import { Label } from '@hospitalrun/components'
import classes from '../../style.module.scss'
import { useTranslation } from 'react-i18next'
import { Select } from 'components/Select'

interface Option {
  title?: string | undefined
  label: string
  value: string | number
  disabled?: boolean
}

interface Props {
  value: string
  label: string
  name: string
  disabled?: boolean
  isEditable?: boolean
  isRequired?: boolean
  isInvalid?: boolean
  feedback?: string
  options: Option[]
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
}

const SelectWithLabelFormGroup = (props: Props) => {
  const {
    value,
    label,
    name,
    isEditable,
    options,
    onChange,
    isRequired,
    isInvalid,
    feedback,
    disabled,
  } = props
  const id = `${name}Select`
  const { t } = useTranslation()

  return (
    <div className="form-group">
      <Label
        className={classes.label}
        text={label}
        htmlFor={id}
        isRequired={isRequired && isEditable}
      />
      {isEditable ? (
        <>
          <Select
            className={classes.select_wrapper}
            disabled={disabled}
            onChange={onChange}
            value={value}
            isInvalid={isInvalid}
          >
            <option disabled value="">
              {`-- ${t('patient.choose')} --`}
            </option>
            {options.map(option => (
              <option
                disabled={option.disabled}
                key={option.value}
                value={option.value}
                title={option.title}
              >
                {option.label}
              </option>
            ))}
          </Select>
          <div className={'text-left ml-3 mt-1 text-small text-danger'}>
            {isInvalid ? feedback : ''}
          </div>
        </>
      ) : (
        <div>
          <pre className="text-secondary">{value}</pre>
          <br />
        </div>
      )}
    </div>
  )
}

SelectWithLabelFormGroup.defaultProps = {
  value: '',
}

export default SelectWithLabelFormGroup
